import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Alert,
} from "reactstrap";
import {
  postMethod
} from "../../../../_services/_postMethod";
import { showErrorToast } from "../../../../_services/notification";
import Loader from "../../../modules/loader";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddCustomer = (props) => {
  let queryParams = useQuery();
  const id = queryParams.get("id") === "" ? null : queryParams.get("id");
  const { register, handleSubmit } = useForm();

  const [load, setLoad] = useState(false);
  const [loadInsert, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");

  const [category, setCategory] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [refList, setRefList] = useState([]);

  const [refDefaultvalue, setRefDefaultvalue] = useState({
    customer_id: "",
    full_name: "",
    mobile: "",
  });
  const emptyReference = {
    customer_id: "",
    full_name: "",
    mobile: "",
  };

  const [param, setParam] = useState({
    customer_id: id == null ? 0 : id,
    mobile: "",
    full_name: "",
    email: "",
    dob: null,
    category_id: null,
    doa: null,
    area_id: null,
    ref_id: null,
    staff_id: null,
    address: "",
    profession: "",
    gender: "",
    sp_bdy: null,
  });

  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);

  const [valid, setValid] = useState({
    mobile: true,
    email: true,
  });
  const [mobileError, setMobileError] = useState("");

  // Insert Data
  const insertData = () => {
    setLoadInsert(true);

    if (param.mobile === "") {
      setValid({ ...valid, mobile: false });
      setMobileError("Mobile number is required");
      showErrorToast("Please fill mobile.");
      setLoadInsert(false);
    } else if (param.mobile.length !== 10) {
      setValid({ ...valid, mobile: false });
      setMobileError("Please enter valid mobile");
      setLoadInsert(false);
    } else {
      param.ref_id = param.ref_id === 0 ? null : param.ref_id;

      postMethod("api/masters/customer/insert", param).then((data) => {
        if (data.data[0].valid) {
          setSuccess(true);
          setTimeout(() => {
            props.history.push("/branch/customer");
          }, 2000);
        } else {
          setLoadInsert(false);
        }
      });
    }
  };

  // Mobile Validation
  const checkMobile = (val) => {
    setParam({ ...param, mobile: val });
    if (val === "") {
      setValid({ ...valid, mobile: false });
      setMobileError("Mobile number is required");
    } else if (val.length !== 10) {
      setValid({ ...valid, mobile: false });
      setMobileError("Please enter valid mobile");
    } else {
      setValid({ ...valid, mobile: true });
      setMobileError("");
    }
  };

  // Email Validation
  const checkEmail = (val) => {
    setParam({ ...param, email: val });
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (regex.test(val)) {
      setValid({ ...valid, email: true });
    } else {
      setValid({ ...valid, email: false });
    }
  };

  const handleDelete = () => {
    var proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (proceed) {
      setLoadDelete(true);
      postMethod("api/masters/customer/delete", {
        customer_id: param.customer_id,
      }).then((data) => {
        if (data.valid) {
          setSuccess(true);
          setSuccessDelete(true);
          setTimeout(() => {
            props.history.push("/branch/customer");
          }, 2000);
        } else {
          setSuccessDelete(true);
          setTimeout(() => {
            setSuccessDelete(false);
          }, 4000);
          setLoadDeleteMsg(data.error);
          setLoadDelete(false);
        }
      });
    }
  };

  useEffect(() => {
    if (id !== null) {
      setLoad(true);
      const temp = window.atob(id);
      postMethod("api/masters/customer/preview", { customer_id: temp }).then(
        (data) => {
          const d = data.data;
          // alert(d.gender);
          setParam({
            ...param,
            customer_id: temp,
            date: d.date ? d.date.split("T")[0] : null,
            mobile: d.mobile,
            email: d.email,
            dob: d.dob ? d.dob.split("T")[0] : null,
            doa: d.doa ? d.doa.split("T")[0] : null,
            full_name: d.full_name,
            category_id: d.category_id,
            area_id: d.area_id,
            ref_id: d.ref_id,
            staff_id: d.staff_id,
            address: d.address,
           gender: d.gender
  ? d.gender.charAt(0).toUpperCase() + d.gender.slice(1).toLowerCase()
  : "",
            profession: d.profession,
            sp_bdy: d.sp_bdy ? d.sp_bdy.split("T")[0] : null,
          });
          setRefDefaultvalue({
            ...refDefaultvalue,
            customer_id: d.ref_id,
            mobile: d.mobile,
            full_name: d.ref_full_name,
          });
          setLoad(false);
        }
      );
    }
    getCategoryList();
    getAreaList();
    getStaffList();
    getRefList();
  }, []);

  const getCategoryList = () => {
    postMethod("api/masters/customer/category/Categorys", {}).then((data) =>
      setCategory(data)
    );
  };

  const getAreaList = () => {
    postMethod("api/customervisit/AreaList").then((res) => {
      setAreaList(res.data);
    });
  };

  const getStaffList = () => {
    postMethod("api/customervisit/StaffList").then((res) => {
      setStaffList(res.data);
    });
  };

  const getRefList = () => {
    postMethod("api/customervisit/ReferenceList").then((res) => {
      setRefList(res.data);
    });
  };

  return (
    <>
      {load ? <Loader /> : null}
      <Form onSubmit={handleSubmit(insertData)} className="add-customer-form">
        <div className="card shadow add-customer-card">
          <div className="add-customer-header">
            <div className="add-customer-title-wrap">
              <span className="add-customer-header-icon">
                <i className="fa fa-user-plus"></i>
              </span>
              <div>
                <h3 className="add-customer-title">
                  {id ? "Edit Customer" : "Add Customer"}
                </h3>
                <p className="add-customer-subtitle">
                  Manage customer contact, dates and reference details.
                </p>
              </div>
            </div>
          </div>
          <div className="card-body add-customer-body">
            <div className="add-customer-section">
              <div className="add-customer-section-title">
                <i className="fa fa-address-card"></i>
                <span>Contact Details</span>
              </div>
              <Row>
                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Full Name</Label>
                  <input
                    type="text"
                    value={param.full_name}
                    className="form-control add-customer-input"
                    name="full_name"
                    placeholder="Enter full name"
                    onChange={(e) =>
                      setParam({ ...param, full_name: e.target.value })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>
                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>
                      Mobile <span className="add-customer-required">*</span>
                    </Label>
                  <input
                    type="number"
                    value={param.mobile}
                    className="form-control add-customer-input"
                    name="mobile"
                    placeholder="10 digit mobile number"
                    onChange={(e) => checkMobile(e.target.value)}
                    ref={register}
                  />
                  {!valid.mobile && (
                    <span className="form-text text-danger">
                      {mobileError || "Please enter valid mobile"}
                    </span>
                  )}
                </FormGroup>
              </Col>
                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Email</Label>
                  <input
                    type="text"
                    value={param.email}
                    className="form-control add-customer-input"
                    name="email"
                    placeholder="Enter email address"
                    onChange={(e) => checkEmail(e.target.value)}
                    ref={register}
                  />
                  {!valid.email && (
                    <span className="form-text text-danger">
                      Please enter valid email
                    </span>
                  )}
                </FormGroup>
              </Col>
                <Col lg={8} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Address</Label>
                    <input
                      type="text"
                      value={param.address}
                      className="form-control add-customer-input"
                      name="address"
                      placeholder="Enter customer address"
                      onChange={(e) =>
                        setParam({ ...param, address: e.target.value })
                      }
                      ref={register}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>

            <div className="add-customer-section">
              <div className="add-customer-section-title">
                <i className="fa fa-calendar"></i>
                <span>Important Dates</span>
              </div>
              <Row>
                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Date of Birth</Label>
                  <TextField
                    type="date"
                    name="dob"
                    value={param.dob || ""}
                    className="add-customer-date-input"
                    fullWidth
                    size="small"
                    ref={register}
                    onChange={(e) =>
                      setParam({ ...param, dob: e.target.value })
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                </FormGroup>
              </Col>

                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Date of Anniversary</Label>
                  <TextField
                    type="date"
                    name="doa"
                    value={param.doa || ""}
                    className="add-customer-date-input"
                    fullWidth
                    size="small"
                    ref={register}
                    onChange={(e) =>
                      setParam({ ...param, doa: e.target.value })
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                </FormGroup>
              </Col>

                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                  <Label>Spouse's Birthday</Label>
                  <TextField
                    type="date"
                    name="sp_bdy"
                    value={param.sp_bdy || ""}
                    className="add-customer-date-input"
                    fullWidth
                    size="small"
                    ref={register}
                    onChange={(e) =>
                      setParam({ ...param, sp_bdy: e.target.value })
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                </FormGroup>
              </Col>
              </Row>
            </div>

            <div className="add-customer-section">
              <div className="add-customer-section-title">
                <i className="fa fa-tags"></i>
                <span>Profile Details</span>
              </div>
              <Row>
                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Gender</Label>
                  <select
                    className="form-control add-customer-input"
                    onChange={(e) =>
                      setParam({ ...param, gender: e.target.value })
                    }
                    name="gender"
                    value={param.gender}
                    ref={register}
                  >
                    <option value="">--Select--</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </FormGroup>
              </Col>

                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Category</Label>
                  <select
                    className="form-control add-customer-input"
                    onChange={(e) =>
                      setParam({ ...param, category_id: e.target.value })
                    }
                    name="category_id"
                    value={param.category_id}
                    ref={register}
                  >
                    <option value="">--Select--</option>
                    {category.map((prop, i) => (
                      <option key={i} value={prop.category_id}>
                        {prop.category_name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
              </Col>

                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Area</Label>
                  <select
                    className="form-control add-customer-input"
                    onChange={(e) =>
                      setParam({ ...param, area_id: e.target.value })
                    }
                    name="area_id"
                    value={param.area_id}
                    ref={register}
                  >
                    <option value="">--Select--</option>
                    {areaList.map((prop, i) => (
                      <option key={i} value={prop.area_id}>
                        {prop.area_name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
              </Col>

                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Staff</Label>
                  <select
                    className="form-control add-customer-input"
                    onChange={(e) =>
                      setParam({ ...param, staff_id: e.target.value })
                    }
                    name="staff_id"
                    value={param.staff_id}
                    ref={register}
                  >
                    <option value="">--Select--</option>
                    {staffList.map((prop, i) => (
                      <option key={i} value={prop.staff_id}>
                        {prop.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
              </Col>

                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Reference</Label>
                  <Autocomplete
                    id="combo-box-demo"
                    size="small"
                    options={refList}
                    className="add-customer-autocomplete"
                    value={refDefaultvalue}
                    onChange={(event, value) => {
                      setParam({
                        ...param,
                        ref_id: value ? value.customer_id : "",
                      });
                      setRefDefaultvalue(value || emptyReference);
                    }}
                    getOptionLabel={(option) => option.full_name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.customer_id === value.customer_id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Reference"
                      />
                    )}
                  />
                </FormGroup>
              </Col>

                <Col lg={4} md={6} sm={12}>
                  <FormGroup className="add-customer-field">
                    <Label>Profession</Label>
                  <input
                    type="text"
                    value={param.profession}
                    className="form-control add-customer-input"
                    name="profession"
                    placeholder="Enter profession"
                    onChange={(e) =>
                      setParam({ ...param, profession: e.target.value })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>
              </Row>
            </div>

            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {successDelete ? (
              <Alert color="danger">{loadDeleteMsg}</Alert>
            ) : null}
          </div>
          <div className="add-customer-footer">
            <a href="/branch/customer" className="btn add-customer-cancel-btn mr-2">
              Cancel
            </a>
            {id &&
              (loadDelete ? (
                <button type="button" className="btn btn-danger mr-2 add-customer-action-btn">
                  Deleting..
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="btn btn-danger mr-2 add-customer-action-btn"
                >
                  Delete
                </button>
              ))}

            {loadInsert ? (
              <button type="button" className="btn btn-primary add-customer-action-btn">
                Saving..
              </button>
            ) : (
              <button type="submit" className="btn btn-primary add-customer-action-btn">
                Save
              </button>
            )}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddCustomer;
